import "bootstrap/dist/css/bootstrap.min.css";
import "react-tooltip/dist/react-tooltip.css";

import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import { DEFAULT_LOCALE, detectInitialLocale, isLocale } from "./i18n/locales";
import BlogIndex from "./pages/Blog/BlogIndex";
import BlogPost from "./pages/Blog/BlogPost";
import { LocaleProvider } from "./i18n/LocaleProvider";
import MainPage from "./pages/MainPage/MainPage";
import Navigation from "./components/navigation/Navigation";
import ProjectPost from "./pages/Projects/ProjectPost";
import ProjectsIndex from "./pages/Projects/ProjectsIndex";
import React from "react";

function LocaleLayout() {
  const { lang } = useParams();
  if (!isLocale(lang)) return <Navigate to={`/${DEFAULT_LOCALE}`} replace />;
  return (
    <LocaleProvider>
      <Navigation />
      <Outlet />
    </LocaleProvider>
  );
}

function RootRedirect() {
  const lang = detectInitialLocale();
  return <Navigate to={`/${lang}`} replace />;
}

function ResumeBackCompat() {
  const { lang } = useParams();
  const { hash } = useLocation();
  return <Navigate to={`/${lang || DEFAULT_LOCALE}${hash || ""}`} replace />;
}

// eslint-disable-next-line no-undef
const PUBLIC_URL = process.env.PUBLIC_URL || "";

const App = () => {
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route
          path="/resume"
          element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />}
        />
        <Route path="/:lang" element={<LocaleLayout />}>
          <Route index element={<MainPage />} />
          <Route path="resume" element={<ResumeBackCompat />} />
          <Route path="blog" element={<BlogIndex />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          <Route path="projects" element={<ProjectsIndex />} />
          <Route path="projects/:slug" element={<ProjectPost />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
